import React from "react";
import c from "../img/c.webp";
import cpp from "../img/cpp.webp";
import css from "../img/css.webp";
import html from "../img/html.webp";
import java from "../img/java.webp";
import js from "../img/js.webp";
import php from "../img/php.webp";
import python from "../img/python.webp";
import reactjs from "../img/reactjs.webp";
import NotesCard, { NotesPdfCard } from "../components/NotesCard";

const Notes = () => {
	const imgs = [c, cpp, css, html, java, js, php, python, reactjs];
	return (
		<div className="page-fit">
			<h1 className="font-bold w-full text-center text-2xl sm:text-3xl p-3 mt-5">
				Download Notes by CodeWithBhavna
			</h1>
			<div className="flex flex-wrap gap-y-5 justify-around gap-4 items-center m-10">
				{Array(9)
					.fill(" ")
					.map((ele, idx) => {
						return <NotesCard key={idx} img={imgs[idx]} />;
					})}
			</div>
			<h1 className="font-bold w-full text-center text-2xl sm:text-3xl p-3 mt-5">
				Download Cheatsheets by CodeWithBhavna
			</h1>
			<div className="flex flex-wrap gap-y-5 justify-around gap-4 items-center m-10">
				{Array(9)
					.fill(" ")
					.map((ele, idx) => {
						return <NotesPdfCard key={idx} img={imgs[idx]} />;
					})}
			</div>
		</div>
	);
};

export default Notes;
